export default "__VITE_ASSET__CN$IuWz6__"